/**
 * Quem pode agir em quem na área de administração (docs/spec/admin.md). O servidor recusa com a
 * mensagem do motivo; a tela desliga o botão e mostra o mesmo motivo como dica.
 */
import type { AdminLogAction, AdminSource } from './domain.js';

/**
 * Por que a ação não vale:
 * - `self`: ninguém age na própria conta (nem se rebaixa: sobraria sem admin quem só tem a tela);
 * - `configured`: o admin da lista do servidor (RPGDESK_ADMINS) só muda por lá;
 * - `admin`: um admin promovido na tela só é rebaixado; suspender, trocar a senha ou apagar vêm
 *   depois de rebaixar;
 * - `suspended`: conta suspensa não vira admin (reative antes).
 *
 * Mudar o plano (docs/spec/planos.md) só tem a primeira regra: não é destrutivo e se desfaz, então vale
 * na conta da lista do servidor, na promovida e na suspensa.
 */
export type AdminRefusal = 'self' | 'configured' | 'admin' | 'suspended';

export type AdminTarget = { id: string; admin: AdminSource | null; suspended: boolean };

export function adminRefusal(actorId: string, target: AdminTarget, action: AdminLogAction): AdminRefusal | null {
  if (actorId === target.id) return 'self';
  if (action === 'plan') return null;
  if (target.admin === 'env') return 'configured';
  if (target.admin === 'db' && action !== 'demote' && action !== 'promote') return 'admin';
  if (action === 'promote' && target.suspended) return 'suspended';
  return null;
}
